import React, { useState, useEffect, useRef } from 'react';
import { useUser } from '../context/UserContext';
import { db } from '../firebaseConfig';
import { toast, ToastContainer } from 'react-toastify';
import { collection, getDoc, getDocs, query, where, doc, addDoc, setDoc, deleteDoc} from 'firebase/firestore';
import './BoloPage.css';
import { httpsCallable } from 'firebase/functions';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { functions } from '../firebaseConfig';
import ActiveBolos from './ActiveBolos';
import PageInfoButton from '../components/PageInfoButton';
import { getStatesWithHomeFirst } from '../utils/states';






const BoloPage = () => {
  const storage = getStorage(undefined, 'blue-wire-e382b.firebasestorage.app');
  const { currentUser } = useUser();

  // Form state
  const [selectedState, setSelectedState] = useState('');
  const [selectedStateTouched, setSelectedStateTouched] = useState(false);
  const [selectedAgencies, setSelectedAgencies] = useState([]);
  const [expiration, setExpiration] = useState('');
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [boloGroups, setBoloGroups] = useState([]);
  const [agenciesInState, setAgenciesInState] = useState([]);
  const [checkedAgencies, setCheckedAgencies] = useState([]);
  const [isAgencyDropdownOpen, setIsAgencyDropdownOpen] = useState(false);
  const [agencyFilter, setAgencyFilter] = useState('');
  const [openMenu, setOpenMenu] = useState(null);
  const [boloText, setBoloText] = useState('');
  const [activeTab, setActiveTab] = useState('active');
  const [isGroupModalOpen, setIsGroupModalOpen] = useState(false);
  const [groupModalAgency, setGroupModalAgency] = useState(null);
  const [selectedGroupId, setSelectedGroupId] = useState('');
  const [editingGroupId, setEditingGroupId] = useState(null);
  const [editingGroupName, setEditingGroupName] = useState('');
  const [openGroupMenu, setOpenGroupMenu] = useState(null);
  const [boloTitle, setBoloTitle] = useState('');
  const [boloErrors, setBoloErrors] = useState([]);
  const [isSaveGroupModalOpen, setIsSaveGroupModalOpen] = useState(false);
  const [newGroupName, setNewGroupName] = useState('');
  const [showTooltip, setShowTooltip] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [mode, setMode] = useState('bolo'); // 'bolo' or 'intel'
  const [anchorEvent, setAnchorEvent] = useState(null);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const [expandedGroupId, setExpandedGroupId] = useState(null);







const agencyDropdownRef = useRef(null);
const groupMenuRef = useRef(null);

  const filteredAgenciesInState = agenciesInState.filter((agency) => {
    if (!agencyFilter.trim()) return true;
    return agency.toLowerCase().startsWith(agencyFilter.trim().toLowerCase());
  });




  useEffect(() => {
    if (!selectedStateTouched && currentUser?.state && !selectedState) {
      setSelectedState(currentUser.state);
    }
  }, [currentUser?.state, selectedState, selectedStateTouched]);





  useEffect(() => {
  if (!selectedState || !currentUser) return;

  const fetchAgencies = async () => {
    const q = query(
      collection(db, 'users'),
      where('state', '==', selectedState)
    );

    const snapshot = await getDocs(q);
    const agenciesSet = new Set();

    snapshot.forEach(doc => {
      const data = doc.data();
      if (data.agency) {
        agenciesSet.add(data.agency);
      }
    });

    const agenciesArray = Array.from(agenciesSet).sort();

    // normalize strings to compare
    const userAgency = currentUser.agency?.toLowerCase().trim();

    const foundIndex = agenciesArray.findIndex(
      a => a.toLowerCase().trim() === userAgency
    );

    if (foundIndex !== -1) {
      const [userAgencyValue] = agenciesArray.splice(foundIndex, 1);
      setAgenciesInState([userAgencyValue, ...agenciesArray]);
    } else {
      setAgenciesInState(agenciesArray);
    }
  };

  fetchAgencies();
}, [selectedState, currentUser]);

  useEffect(() => {
    setAgencyFilter('');
  }, [selectedState, isAgencyDropdownOpen]);




    useEffect(() => {
  if (!currentUser?.uid) return;

  const fetchBoloGroups = async () => {
    const q = collection(db, 'users', currentUser.uid, 'boloGroups');
    const snapshot = await getDocs(q);
    const groups = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    setBoloGroups(groups);
  };

  fetchBoloGroups();
}, [currentUser]);



	useEffect(() => {
  const handleClickOutside = (e) => {
    // Don’t trigger if clicking a menu button itself
    if (e.target.closest('.menu-button')) return;

    const menu = document.querySelector('.group-menu');
    if (menu && !menu.contains(e.target)) setOpenGroupMenu(null);

    const recipientMenu = document.querySelector('.recipient-menu');
    if (recipientMenu && !recipientMenu.contains(e.target)) setOpenMenu(null);
  };

  // use mousedown to ensure React onClick fires first
  document.addEventListener('mousedown', handleClickOutside);

  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, [openGroupMenu, openMenu]);




const confirmAndRemoveAgency = (agencyName) => {
  toast.info(
    <div>
      <p>Remove <strong>{agencyName}</strong> from recipients?</p>
      <div style={{ marginTop: '8px', textAlign: 'right' }}>
        <button
          onClick={() => {
            setSelectedAgencies(prev => prev.filter(a => a.name !== agencyName));
            toast.dismiss();
          }}
          style={{
            backgroundColor: 'red',
            color: 'white',
            border: 'none',
            padding: '4px 8px',
            marginRight: '8px',
            cursor: 'pointer'
          }}
        >
          Yes
        </button>
        <button
          onClick={() => toast.dismiss()}
          style={{
            backgroundColor: '#ccc',
            border: 'none',
            padding: '4px 8px',
            cursor: 'pointer'
          }}
        >
          No
        </button>
      </div>
    </div>,
    { autoClose: false }
  );
};



	const handleSendBolo = async () => {
  if (!currentUser) return;

  const senderName = `${currentUser.rank} ${currentUser.firstInitialLastName}, ${currentUser.agency}, ${currentUser.state}`;
  const senderUid = currentUser.uid;

  const recipients = selectedAgencies.filter(a => a.include).map(a => a.name);

  if (!boloTitle.trim() || !boloText.trim() || recipients.length === 0 || !expiration) {
    toast.error("Please fill all required fields: title, message, recipients, expiration.");
    return;
  }

  let fileUrls = [];

  if (attachedFiles.length > 0) {
    try {
      for (const item of attachedFiles) {
        const fileRef = ref(storage, `bolos/${Date.now()}_${item.file.name}`);
        await uploadBytes(fileRef, item.file);
        const url = await getDownloadURL(fileRef);
        fileUrls.push(url);
      }
      console.log("✅ Files uploaded to Storage:", fileUrls);
    } catch (err) {
      console.error("❌ Failed to upload one or more files:", err);
      toast.error("Failed to upload attachments.");
      return;
    }
  }

  const createdAt = new Date();
  const expirationHours = parseInt(expiration, 10);
  const expiresAt = new Date(createdAt.getTime() + expirationHours * 60 * 60 * 1000);

  const boloData = {
    title: boloTitle.trim(),
    text: boloText.trim(),
    recipients,
    expiration, // keep the string value
    senderId: senderUid,
    senderName,
    createdAt,
    expiresAt,
    attachedFileUrls: fileUrls,
    type: mode === 'intel' ? 'intel' : 'bolo', // 👈 distinguish between BOLO and Intel
  };

  console.log("🔷 Saving BOLO/Intel to Firestore:", boloData);

  try {
    const boloRef = await addDoc(collection(db, "bolos"), boloData);

    console.log('✅ Saved with ID:', boloRef.id);

    const sendBoloNotification = httpsCallable(functions, 'sendBoloNotification');

    const notificationResult = await sendBoloNotification({
      title: boloData.title,
      text: boloData.text,
      recipients,
      sender: senderName,
      type: boloData.type,
    });

    console.log('🔷 Notification result:', notificationResult);

    if (notificationResult.data?.success) {
      toast.success(`${mode === 'intel' ? 'Intel' : 'BOLO'} sent! Notifications: ${notificationResult.data.sent}/${notificationResult.data.total}`);
    } else {
      toast.warn(`${mode === 'intel' ? 'Intel' : 'BOLO'} sent, but no push notifications delivered.`);
    }

    setBoloTitle('');
    setBoloText('');
    setSelectedAgencies([]);
    setExpiration('');
    setAttachedFiles([]);
    const uploadInput = document.getElementById('bolo-picture-upload');
    if (uploadInput) uploadInput.value = '';

  } catch (error) {
    console.error("❌ Error saving or sending notifications:", error);
    toast.error(`Failed to send ${mode === 'intel' ? 'Intel' : 'BOLO'}. Please try again.`);
  }
};






  const confirmAndRemoveAgencyFromGroup = (group, agencyName) => {
  toast.info(
    <div>
      <p>Remove <strong>{agencyName}</strong> from group <strong>{group.name}</strong>?</p>
      <div style={{ marginTop: '8px', textAlign: 'right' }}>
        <button
          onClick={async () => {
            const groupRef = doc(db, 'users', currentUser.uid, 'boloGroups', group.id);
            const updatedAgencies = group.agencies.filter(a => a !== agencyName);

            await setDoc(groupRef, {
              ...group,
              agencies: updatedAgencies
            });

            setBoloGroups(prev => prev.map(g =>
              g.id === group.id ? { ...g, agencies: updatedAgencies } : g
            ));

            toast.dismiss();
            toast.success(`Removed "${agencyName}" from "${group.name}"`);
          }}
          style={{
            backgroundColor: 'red',
            color: 'white',
            border: 'none',
            padding: '4px 8px',
            marginRight: '8px',
            cursor: 'pointer'
          }}
        >
          Yes
        </button>
        <button
          onClick={() => toast.dismiss()}
          style={{
            backgroundColor: '#ccc',
            border: 'none',
            padding: '4px 8px',
            cursor: 'pointer'
          }}
        >
          No
        </button>
      </div>
    </div>,
    { autoClose: false }
  );
};



	const validateBolo = () => {
  const errors = [];

  if (selectedAgencies.filter(a => a.include).length === 0) {
    errors.push('At least one agency must be selected.');
  }
  if (boloTitle.trim() === '') {
    errors.push('Title is required.');
  }
  if (boloText.trim() === '') {
    errors.push('Message text is required.');
  }
  if (expiration === '') {
    errors.push('Expiration time must be set.');
  }

  return errors;
};


	useEffect(() => {
  function handleClickOutside(event) {
    if (
      isAgencyDropdownOpen &&
      agencyDropdownRef.current &&
      !agencyDropdownRef.current.contains(event.target)
    ) {
      setIsAgencyDropdownOpen(false);
      setCheckedAgencies([]);
      setSelectedGroupId('');
    }
  }

  document.addEventListener('mousedown', handleClickOutside);

  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, [isAgencyDropdownOpen]);






  return (
    <div className="bolo-page">
      <div className="page-info-header-block">
        <h2 style={{ margin: 0, fontSize: '28px', textAlign: 'center' }}>BOLO & Intel Hub</h2>
        <div className="page-info-button-wrapper">
          <PageInfoButton title="About the BOLO Hub">
            <p>Broadcast time-sensitive BOLOs or share structured intelligence packages with other agencies.</p>
            <ul className="page-info-list">
              <li><strong>Active tab:</strong> This is where all active BOLOs and Intel messages will show. You can contact the sender directly by clicking the name at the bottom of the BOLO/Intel message.</li>
              <li><strong>Send Tab:</strong> This is where you can create and send BOLO and Intel messages. They will appear in the appropriate tab in the "Active" section. <u>Remember: if you do not include your agency as a Recipient, you will not see the active message in your account (as no one in your agency will)!</u></li>
              <li><strong>Targeted recipients:</strong> Filter by state, and pick agencies to receive your message. You can also use saved recipient groups for convenience.</li>
              <li><strong>Attachments & lifecycle:</strong> You can add relevant files and set expirations. The message (BOLO/Intel) will auto-expire after the selected time.</li>
            </ul>
          </PageInfoButton>
        </div>
      </div>
      <div className="bolo-tabs">
	<div className="bolo-title">
  
</div>
        <button className={activeTab === 'active' ? 'active' : ''} onClick={() => setActiveTab('active')}>Active</button>
        <button className={activeTab === 'send' ? 'active' : ''} onClick={() => setActiveTab('send')}>Send</button>
      </div>

     {activeTab === 'active' && <ActiveBolos />}


    {activeTab === 'send' && (
  <div className={`send-bolo-form ${mode}`}>
    {/* ==== MODE TOGGLE ==== */}
    <div className="mode-toggle-wrapper">
      <div className="mode-toggle">
        <span className={`toggle-label ${mode === 'bolo' ? 'active' : ''}`}>Send BOLO</span>
        <label className="switch">
          <input
            type="checkbox"
            checked={mode === 'intel'}
            onChange={(e) => setMode(e.target.checked ? 'intel' : 'bolo')}
          />
          <span className={`slider ${mode}`}></span>
        </label>
        <span className={`toggle-label ${mode === 'intel' ? 'active' : ''}`}>Share Intel</span>
      </div>
    </div>

    <h2 className={`page-title mode-heading ${mode}`}>
      {mode === 'intel' ? 'Share Intel' : 'Send BOLO'}
    </h2>

    {/* ==== STATE & AGENCIES ==== */}
    <div className="bolo-section">
      <div className="state-agencies-line">
        <span>Agencies in:</span>
        <select
          value={selectedState}
          onChange={(e) => {
            setSelectedStateTouched(true);
            setSelectedState(e.target.value);
          }}
        >
          {getStatesWithHomeFirst(currentUser?.state).map((state) => (
            <option key={state} value={state}>{state}</option>
          ))}
        </select>

        <button
          onClick={() => setIsAgencyDropdownOpen((p) => !p)}
          className={`dropdown-toggle ${mode}`}
        >
          {isAgencyDropdownOpen ? '▲ Hide' : '▼ Select Agencies'}
        </button>
      </div>

      {isAgencyDropdownOpen && (
        <div ref={agencyDropdownRef} className="agency-dropdown">
          <p style={{ fontStyle: 'italic', fontSize: '0.9rem', marginBottom: '8px' }}>
            It’s good practice to include your agency.
          </p>
          <input
            type="text"
            value={agencyFilter}
            onChange={(e) => setAgencyFilter(e.target.value)}
            placeholder="Search agencies"
            className="agency-filter-input"
          />
	    <div className="agency-list">
          {filteredAgenciesInState.map((agency) => (
            <div
              key={agency}
              onClick={() => {
                setCheckedAgencies((prev) =>
                  prev.includes(agency)
                    ? prev.filter((a) => a !== agency)
                    : [...prev, agency]
                );
              }}
              className="agency-option"
            >
              <input
                type="checkbox"
                checked={checkedAgencies.includes(agency)}
                readOnly
              />
              {agency}
            </div>
          ))}
          {filteredAgenciesInState.length === 0 && (
            <p className="agency-filter-empty">No agencies found.</p>
          )}
	</div>
          <div className="agency-dropdown-buttons">
            <button
              onClick={async () => {
                if (selectedGroupId) {
                  const groupRef = doc(db, 'users', currentUser.uid, 'boloGroups', selectedGroupId);
                  const snap = await getDoc(groupRef);
                  if (!snap.exists()) {
                    toast.error('Group no longer exists.');
                    setIsAgencyDropdownOpen(false);
                    setCheckedAgencies([]);
                    setSelectedGroupId('');
                    return;
                  }
                  const data = snap.data();
                  const updated = [...new Set([...data.agencies, ...checkedAgencies])];
                  await setDoc(groupRef, { ...data, agencies: updated });
                  setBoloGroups((prev) =>
                    prev.map((g) => (g.id === selectedGroupId ? { ...g, agencies: updated } : g))
                  );
                  toast.success(`Added agencies to group "${data.name}"`);
                  setSelectedGroupId('');
                } else {
                  const newRecipients = checkedAgencies
                    .filter((a) => !selectedAgencies.some((x) => x.name === a))
                    .map((a) => ({ name: a, include: true }));
                  setSelectedAgencies((prev) => [...prev, ...newRecipients]);
                }
                setCheckedAgencies([]);
                setIsAgencyDropdownOpen(false);
              }}
              disabled={checkedAgencies.length === 0}
              className="add-selected-button"
            >
              + Add Selected
            </button>
            <button
              onClick={() => {
                setCheckedAgencies([]);
                setIsAgencyDropdownOpen(false);
                setSelectedGroupId('');
              }}
              className="modal-cancel-button"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
	
    {/* ==== SAVED GROUPS ==== */}
    <div className="bolo-section">
      <div className="bolo-groups">
        <h4 className="saved-groups-heading">
          <span>Saved Groups</span>
          <button
            className="create-group-btn"
            onClick={() => {
              const groupName = prompt('Enter name for new group:');
              if (!groupName) return;
              const newGroup = { name: groupName.trim(), agencies: [] };
              const groupRef = doc(collection(db, 'users', currentUser.uid, 'boloGroups'));
              setDoc(groupRef, newGroup)
                .then(() => {
                  setBoloGroups((p) => [...p, { id: groupRef.id, ...newGroup }]);
                  toast.success(`Created group "${groupName}"`);
                })
                .catch(() => toast.error('Failed to create group.'));
            }}
          >
            + Create Group
          </button>
        </h4>

        {boloGroups.length === 0 ? (
          <p style={{ color: '#888' }}>No saved groups yet.</p>
        ) : (
          <ul>
            {boloGroups.map((group) => (
              <li key={group.id} className="group-row" style={{ position: 'relative', marginBottom: '10px' }}>
  {/* HEADER: button + group name in one horizontal line */}
  <div
    className="group-header"
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      gap: '8px',
      position: 'relative',
      zIndex: 2,
    }}
  >
    <div className="recipient-actions">
      <button
        className="menu-button"
        onClick={(e) => {
          e.stopPropagation();
          const rect = e.currentTarget.getBoundingClientRect();
          setMenuPosition({
            top: rect.bottom + window.scrollY + 6,
            left: rect.left + 10,
          });
          setOpenGroupMenu(openGroupMenu === group.id ? null : group.id);
        }}
      >
        ⋮
      </button>
    </div>

    <div style={{ flexGrow: 1 }}>
      {editingGroupId === group.id ? (
        <input
          type="text"
          value={editingGroupName}
          onChange={(e) => setEditingGroupName(e.target.value)}
          onBlur={async () => {
            const trimmed = editingGroupName.trim();
            if (trimmed && trimmed !== group.name) {
              const ref = doc(db, 'users', currentUser.uid, 'boloGroups', group.id);
              await setDoc(ref, { ...group, name: trimmed });
              setBoloGroups((p) =>
                p.map((g) => (g.id === group.id ? { ...g, name: trimmed } : g))
              );
            }
            setEditingGroupId(null);
            setEditingGroupName('');
          }}
          autoFocus
        />
      ) : (
        <strong
          style={{ cursor: 'pointer' }}
          onClick={() =>
            setExpandedGroupId((prev) => (prev === group.id ? null : group.id))
          }
        >
          {group.name}
        </strong>
      )}
    </div>
  </div>

  {/* EXPANDED MEMBERS: appear under the header */}
  {expandedGroupId === group.id && (
    <div
      style={{
        marginTop: '6px',
        marginLeft: '28px',
        textAlign: 'left',
        display: 'block',
        width: 'calc(100% - 28px)',
      }}
    >
      {group.agencies.length === 0 ? (
        <p style={{ fontStyle: 'italic', fontSize: '0.9rem', color: '#666' }}>
          (No agencies yet)
        </p>
      ) : (
        <ul
          style={{
            listStyleType: 'circle',
            paddingLeft: '16px',
            color: '#444',
            marginTop: '4px',
          }}
        >
          {group.agencies.map((agency) => (
            <li
              key={agency}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                marginBottom: '4px',
              }}
            >
              <span>{agency}</span>
              <button
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'red',
                  cursor: 'pointer',
                  fontSize: '14px',
                }}
                onClick={() => confirmAndRemoveAgencyFromGroup(group, agency)}
              >
                ❌
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  )}
</li>

))}  
</ul>
)}


{/* === GROUP MENU MODAL === */}
{openGroupMenu && (
  <div
    className="recipient-menu group-menu"
    style={{
      position: 'absolute',
      top: `${menuPosition.top}px`,
      left: `${menuPosition.left}px`,
      background: '#ffffff',
      border: '1px solid #cbd5e1',
      borderRadius: '8px',
      boxShadow: '0 4px 14px rgba(0,0,0,0.3)',
      padding: '8px 10px',
      width: '190px',
      zIndex: 2147483647,
      isolation: 'isolate',
    }}
  >
    <div
      className="recipient-menu-item"
      onClick={() => {
        const group = boloGroups.find((g) => g.id === openGroupMenu);
        if (!group) return;
        const newRecipients = group.agencies
          .filter((a) => !selectedAgencies.some((x) => x.name === a))
          .map((a) => ({ name: a, include: true }));
        setSelectedAgencies((p) => [...p, ...newRecipients]);
        toast.success(`Added group "${group.name}" to recipients`);
        setOpenGroupMenu(null);
      }}
      style={{ cursor: 'pointer', marginBottom: '8px' }}
    >
      ➕ Add to Recipients
    </div>

    <div
      className="recipient-menu-item"
      onClick={() => {
        const group = boloGroups.find((g) => g.id === openGroupMenu);
        if (!group) return;
        setEditingGroupId(group.id);
        setEditingGroupName(group.name);
        setOpenGroupMenu(null);
      }}
      style={{ cursor: 'pointer', marginBottom: '8px' }}
    >
      ✏️ Rename
    </div>

    <div
      className="recipient-menu-item"
      style={{ color: 'red', cursor: 'pointer' }}
      onClick={async () => {
        const group = boloGroups.find((g) => g.id === openGroupMenu);
        if (!group) return;
        await deleteDoc(doc(db, 'users', currentUser.uid, 'boloGroups', group.id));
        setBoloGroups((p) => p.filter((g) => g.id !== group.id));
        toast.success(`Deleted "${group.name}"`);
        setOpenGroupMenu(null);
      }}
    >
      ❌ Delete
    </div>
  </div>
)}  {/* end of modal block */}

         
      </div>  {/* end of .bolo-groups */}
    </div>  {/* end of .bolo-section (Saved Groups) */}


    {/* ==== RECIPIENTS ==== */}
    <div className="bolo-section">
      <div className="selected-agencies">
        <h4>
          ▼ {mode === 'intel' ? 'Intel Recipients' : 'BOLO Recipients'} ▼{' '}
          <span style={{ color: 'red' }}>*</span>
        </h4>
        {selectedAgencies.length === 0 ? (
          <p style={{ color: '#888' }}>No agencies selected yet.</p>
        ) : (
        <ul>
  {selectedAgencies.map((agency, index) => (
    <li key={agency.name} className="recipient-row">
      <div className="recipient-info">
        <label className="toggle-switch">
          <input
            type="checkbox"
            checked={agency.include}
            onChange={() => {
              const updated = [...selectedAgencies];
              updated[index].include = !updated[index].include;
              setSelectedAgencies(updated);
              setBoloErrors([]);
            }}
          />
          <span className="slider"></span>
        </label>
        <span className="recipient-name">{agency.name}</span>
      </div>

      <div className="recipient-actions">
        <button
          className="menu-button"
          onClick={(e) => {
            e.stopPropagation();
            setOpenMenu(openMenu === index ? null : index);
          }}
        >
          ⋮
        </button>

        {openMenu === index && (
          <div className="recipient-menu">
            <div
              className="recipient-menu-item"
              onClick={() => {
                confirmAndRemoveAgency(agency.name);
                setOpenMenu(null);
              }}
            >
              🗑 Remove
            </div>

            <div
              className="recipient-menu-item"
              onClick={() => {
                setGroupModalAgency(agency.name);
                setIsGroupModalOpen(true);
                setOpenMenu(null);
              }}
            >
              📁 Add to Group
            </div>
          </div>
        )}
      </div>
    </li>
  ))}
</ul>

        )}
      </div>
    </div>

	<button
  onClick={() => setIsSaveGroupModalOpen(true)}
  className={`save-group-button ${mode}`}
  style={{
    marginTop: '10px',
  }}
>
  💾 Save Current as Group
</button>


	
    {/* ==== TITLE + MESSAGE ==== */}
    <div className="bolo-section">
      <label>
        Title: <span style={{ color: 'red' }}>*</span>
      </label>
      <input
        type="text"
        value={boloTitle}
        onChange={(e) => setBoloTitle(e.target.value)}
        placeholder="e.g. Suspicious Activity, Vehicle, Subject..."
        style={{ width: '100%', marginBottom: '8px' }}
      />
    </div>

    <div className="bolo-section">
      <label>
        {mode === 'intel' ? 'Intel Message:' : 'BOLO Message:'}{' '}
        <span style={{ color: 'red' }}>*</span>
      </label>
      <textarea
        value={boloText}
        onChange={(e) => {
          setBoloText(e.target.value);
          e.target.style.height = 'auto';
          e.target.style.height = Math.max(e.target.scrollHeight, 180) + 'px';
        }}
        placeholder={
          mode === 'intel'
            ? 'Enter Intel message here...'
            : 'Enter BOLO message here...'
        }
        style={{ minHeight: '180px', width: '100%', resize: 'none' }}
      />
    </div>

    {/* ==== ATTACHMENTS ==== */}
    <div className="bolo-section attachment-section">
      <input
        type="file"
        accept="image/*"
        id="bolo-picture-upload"
        multiple
        style={{ display: 'none' }}
        onChange={(e) => {
          const files = Array.from(e.target.files).map((f) => ({
            file: f,
            previewUrl: URL.createObjectURL(f),
          }));
          setAttachedFiles((p) => [...p, ...files]);
        }}
      />
      <button
        onClick={(e) => {
          e.preventDefault();
          document.getElementById('bolo-picture-upload').click();
        }}
        className="upload-picture-button"
      >
        📎 Attach Images
      </button>

      {attachedFiles.length > 0 && (
        <div className="attachment-preview">
          {attachedFiles.map((item, idx) => (
            <div key={idx} className="attachment-item">
              <img src={item.previewUrl} alt="Preview" />
              <button
                onClick={(e) => {
                  e.preventDefault();
                  URL.revokeObjectURL(item.previewUrl);
                  setAttachedFiles((p) => p.filter((_, i) => i !== idx));
                }}
              >
                ❌
              </button>
            </div>
          ))}
        </div>
      )}
    </div>

    {/* ==== EXPIRATION + SEND ==== */}
    <div className="bolo-section send-row">
      <div>
        <label>
          Expires In: <span style={{ color: 'red' }}>*</span>
        </label>
        <select value={expiration} onChange={(e) => setExpiration(e.target.value)}>
          <option value="">Select duration</option>
          {mode === 'intel' ? (
            <>
              <option value="12">12 hours</option>
              <option value="24">24 hours</option>
              <option value="48">48 hours</option>
            </>
          ) : (
            <>
              <option value="2">2 hours</option>
              <option value="4">4 hours</option>
              <option value="6">6 hours</option>
              <option value="8">8 hours</option>
              <option value="12">12 hours</option>
            </>
          )}
        </select>
      </div>

      <button
        onClick={() => {
          if (isSending) return;
          const errors = validateBolo();
          if (errors.length > 0) return setBoloErrors(errors);
          setIsSending(true);
          handleSendBolo().finally(() => setIsSending(false));
        }}
        className={`send-bolo-button ${mode}`}
        disabled={isSending}
      >
        {isSending ? 'Sending…' : mode === 'intel' ? 'Send Intel' : 'Send BOLO'}
      </button>
    </div>

    {boloErrors.length > 0 && (
      <div style={{ marginTop: '8px' }}>
        {boloErrors.map((err, i) => (
          <p key={i} style={{ color: 'red', margin: 0 }}>
            {err}
          </p>
        ))}
      </div>
    )}
  </div>
)}



	{isSaveGroupModalOpen && (
  <div className="modal-overlay">
    <div className="modal">
      <h3>Create BOLO Group</h3>
      <p style={{ fontSize: '0.9rem', marginBottom: '8px' }}>
        The current BOLO recipients will be saved under this group.
      </p>

      <input
        type="text"
        placeholder="Group Name"
        value={newGroupName}
        onChange={(e) => setNewGroupName(e.target.value)}
        style={{ width: '100%', padding: '6px', marginBottom: '12px', border: '1px solid #ccc', borderRadius: '4px' }}
      />

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
        <button
          onClick={() => {
            setIsSaveGroupModalOpen(false);
            setNewGroupName('');
          }}
          className="modal-cancel-button"
        >
          Cancel
        </button>

        <button
       onClick={async () => {
  if (!newGroupName.trim() || selectedAgencies.length === 0) return;

  const groupRef = await addDoc(
    collection(db, 'users', currentUser.uid, 'boloGroups'),
    {
      name: newGroupName.trim(),
      agencies: selectedAgencies.map(a => a.name)
    }
  );

  setBoloGroups(prev => [
    ...prev,
    {
      id: groupRef.id,
      name: newGroupName.trim(),
      agencies: selectedAgencies.map(a => a.name)
    }
  ]);

  setNewGroupName('');
  setIsSaveGroupModalOpen(false);
  toast.success(`Group "${newGroupName.trim()}" created`);
}}

          className="save-group-button"
        >
          Save
        </button>
      </div>
    </div>
  </div>
)}
	


	{isGroupModalOpen && (
  <div className="modal-overlay">
    <div className="modal">
      <h3>Add "{groupModalAgency}" to Group</h3>

      {boloGroups.length === 0 ? (
        <p>No saved groups yet.</p>
      ) : (
        <select
	  className="group-select"
          value={selectedGroupId}
          onChange={(e) => setSelectedGroupId(e.target.value)}
        >
          <option value="">Select a group</option>
          {boloGroups.map(group => (
            <option key={group.id} value={group.id}>
              {group.name}
            </option>
          ))}
        </select>
      )}

      <div style={{ marginTop: '12px' }}>
        <button
	  className="modal-add-button"
          onClick={async () => {
            if (!selectedGroupId || !groupModalAgency) return;

            const groupRef = doc(db, 'users', currentUser.uid, 'boloGroups', selectedGroupId);
            const groupSnap = await getDoc(groupRef);

            if (!groupSnap.exists()) {
              toast.error("Group no longer exists.");
              setIsGroupModalOpen(false);
              setSelectedGroupId('');
              setGroupModalAgency(null);
              return;
            }

            const groupData = groupSnap.data();
            const updatedAgencies = groupData.agencies.includes(groupModalAgency)
              ? groupData.agencies
              : [...groupData.agencies, groupModalAgency];

      // Immediately update UI
setBoloGroups(prev => prev.map(g =>
  g.id === selectedGroupId
    ? { ...g, agencies: [...new Set([...g.agencies, groupModalAgency])] }
    : g
));

            await setDoc(groupRef, {
              ...groupData,
              agencies: updatedAgencies
            });

            toast.success(`Added ${groupModalAgency} to ${groupData.name}`);
            setIsGroupModalOpen(false);
            setSelectedGroupId('');
            setGroupModalAgency(null);
          }}
          disabled={!selectedGroupId}
        >
          Add
        </button>

        <button
	  className="modal-cancel-button"
          onClick={() => {
            setIsGroupModalOpen(false);
            setSelectedGroupId('');
            setGroupModalAgency(null);
          }}
          style={{ marginLeft: '8px' }}
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)}


      <ToastContainer />
    </div>
  );
};

export default BoloPage;
